import React from 'react'

import HeroSection from '../Components/HomePage/HeroSection'

const Home = () => {
  return (
    <div >
     <HeroSection/>
    </div>
  )
}

export default Home